import React from "react";
import { CellProps } from "react-table";
import AgTable from "../../../components/AgTable";
import { Log } from "../../../models";
import { DEFAULT_VALUE, OFFERING_TYPE } from "../../../utils/constant";
import { convertOfferingToName } from "../../../utils/convertHelper";
import { formatDateTimeNoSecond, formatDateTimeToLocalTime } from "../../../utils/helper";
import { IPageViewTabProps } from "./pageViewTab.props";

const PageViewTab: React.FC<IPageViewTabProps> = ({
	data,
	maxLength,
	entriesPerPage = DEFAULT_VALUE.ENTRIES_PER_PAGE,
	onHandleNextPage,
	pageCount,
	page = 1,
	isLoading,
	offeringType,
	...props
}: IPageViewTabProps) => {
	const columns = React.useMemo(
		() => [
			{
				Header: "User",
				width: "20%",
				Cell: ({ cell, row }: CellProps<Log, any>) => {
					const rowData = row.original;

					return (
						<div className="flex flex-col items-start">
							<p className="text-[14px] text-[#58585B] font-medium m-0 p-0">{`${rowData.fkIndividual?.firstName} ${rowData.fkIndividual?.lastName}`}</p>
							<p className="text-[14px] text-[#637381] font-normal m-0 p-0">
								{rowData.fkIndividual?.individualEmailAddr}
							</p>
						</div>
					);
				},
			},
			{
				Header: "Organization",
				width: "22%",
				Cell: ({ cell, row }: CellProps<Log, any>) => {
					const rowData = row.original;

					return (
						<p className="">
							{rowData.fkIndividual?.fkOrg?.orgName}
						</p>
					);
				},
			},
			{
				Header: "Action",
				width: "8%",
				Cell: ({ cell, row }: CellProps<Log, any>) => {
					const rowData = row.original;

					return <p className="">{rowData.actionLog}</p>;
				},
			},
			{
				Header: `Organization Profile ${offeringType !== OFFERING_TYPE.ORGANIZATION ? `- ${convertOfferingToName(offeringType ?? OFFERING_TYPE.SERVICE)}` : ""}`,
				width: "28%",
				Cell: ({ cell, row }: CellProps<Log, any>) => {
					const rowData = row.original;

					return (
						rowData.fkToOrg && (
							<p className="">{`${rowData.fkToOrg?.orgName} ${rowData.mainServiceName
								? " - " + rowData.mainServiceName
								: ""
								} `}</p>
						)
					);
				},
			},
			{
				Header: "Time stamp",
				width: "15%",
				Cell: ({ cell, row }: CellProps<Log, any>) => {
					const rowData = row.original;

					return (
						<p className="">
							{formatDateTimeNoSecond(formatDateTimeToLocalTime(rowData.createdAt))}
						</p>
					);
				},
			},
		],
		[offeringType],
	);

	return (
		<AgTable
			columns={columns}
			data={data}
			maxLength={maxLength}
			entriesPerPage={entriesPerPage}
			onHandleNextPage={onHandleNextPage}
			pageCount={pageCount}
			page={page}
			isLoading={isLoading}
		/>
	);
};

export default React.memo(PageViewTab);
